import { motion } from "framer-motion";
import { RevealLines } from "@/components/RevealText";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { Link } from "react-router-dom";

const IMGS = [
    { src: "https://images.unsplash.com/photo-1705254772179-991469a47e19?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85", label: "Foil Bubble · Detail", ratio: "aspect-[3/4]" },
    { src: "https://images.unsplash.com/photo-1772300704502-410f0fbd43bb?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85", label: "Warehouse Interior", ratio: "aspect-[4/3]" },
    { src: "https://images.unsplash.com/photo-1771970472779-6452fbce94d6?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85", label: "Metal Roof Structure", ratio: "aspect-square" },
    { src: "https://images.unsplash.com/photo-1784739893954-b64adc267d62?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85", label: "Aluminium Foil Texture", ratio: "aspect-[4/5]" },
    { src: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85", label: "Commercial Building", ratio: "aspect-[3/4]" },
    { src: "https://images.unsplash.com/photo-1772300704502-410f0fbd43bb?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85&sat=-100", label: "Insulation In Situ", ratio: "aspect-[16/10]" },
    { src: "https://images.unsplash.com/photo-1705254772179-991469a47e19?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85&sat=-40", label: "Foil Layer", ratio: "aspect-square" },
    { src: "https://images.unsplash.com/photo-1771970472779-6452fbce94d6?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85&sat=-40", label: "Industrial Ceiling", ratio: "aspect-[4/3]" },
];

const Gallery = () => (
    <div data-testid="gallery-page">
        <section className="pt-40 pb-16 border-b border-white/10">
            <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
                <Breadcrumbs items={[{ label: "Gallery", to: "/gallery" }]} />
                <div className="mt-10 flex items-center gap-4">
                    <div className="h-px w-12 bg-edge" />
                    <span className="text-[10px] tracking-[0.35em] text-edge uppercase font-bold">Gallery</span>
                </div>
                <RevealLines
                    as="h1"
                    lines={["Product. Texture.", <>The <span className="text-edge">material</span> up close.</>]}
                    className="mt-8 font-display font-black uppercase tracking-tighter text-[12vw] md:text-[9vw] lg:text-[6.5vw] leading-[0.9]"
                />
                <p className="mt-6 text-white/70 max-w-2xl">
                    A curated look at the products we supply and the environments they protect. Completed project photos coming soon.
                </p>
            </div>
        </section>

        <section className="py-16 border-b border-white/10">
            <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                    {IMGS.map((img, i) => (
                        <motion.figure
                            key={i}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, delay: (i % 3) * 0.06 }}
                            viewport={{ once: true, margin: "-80px" }}
                            className={`relative overflow-hidden ${img.ratio} bg-ink-800 ${i % 5 === 0 ? "md:col-span-2 lg:col-span-2" : ""}`}
                            data-testid={`gallery-item-${i}`}
                        >
                            <img src={img.src} alt={img.label} className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1400ms]" />
                            <figcaption className="absolute bottom-4 left-4 text-[10px] tracking-[0.3em] text-white/90 uppercase bg-ink-950/60 backdrop-blur-sm px-3 py-1.5">
                                {img.label}
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>

        <section className="py-24 border-b border-white/10">
            <div className="max-w-[1200px] mx-auto px-6 lg:px-12 text-center">
                <h2 className="font-display uppercase text-4xl md:text-5xl font-black tracking-tighter">
                    Want to see it on your roof?
                </h2>
                <Link
                    to="/contact"
                    className="mt-10 inline-flex items-center gap-2 bg-edge text-ink-950 font-bold text-sm px-8 py-5 uppercase tracking-wider hover:bg-edge-hover"
                    data-testid="gallery-cta"
                >
                    Book Free Site Inspection →
                </Link>
            </div>
        </section>
    </div>
);

export default Gallery;
